export const safeParseInt = (value: any, defaultValue: number): number => {
  const parsedValue = value ? parseInt(value, 10) : null;
  if (parsedValue != null && Number.isInteger(parsedValue)) {
    return parsedValue;
  }
  return defaultValue;
};

export const safeParsePositiveInt = (
  value: any,
  defaultValue: number,
): number => {
  const parsedValue = safeParseInt(value, defaultValue);
  if (parsedValue !== null && parsedValue > 0) {
    return parsedValue;
  }
  return defaultValue;
};
